/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { t } from "i18next";
import React from "react";

interface ProductMasterFilterBarProps {
  mediaTypes: any[];
  selectedMediaType: string;
  searchTerm: string;
  manufacturerFilter?: string;
  statusFilter?: string;

  onMediaTypeChange: (val: string) => void;
  onSearchChange: (val: string) => void;
  onClearFilters: () => void;
  onManufacturerChange?: (val: string) => void;
  onStatusChange?: (val: string) => void;
  totalElements: number;
  filterLabel?: string;        
  filterPlaceholder?: string;
  valueKey?: string;
  labelKey?: string;
  onSearchClick?: () => void;
}

const ProductMasterFilterBar: React.FC<ProductMasterFilterBarProps> = ({
  mediaTypes,
  selectedMediaType,
  searchTerm,
  onMediaTypeChange,
  onSearchChange,
  onClearFilters,
  filterLabel,
  filterPlaceholder,
  valueKey,
  labelKey,
  onSearchClick,
  totalElements,
  manufacturerFilter,
  statusFilter,
  onManufacturerChange,
  onStatusChange,

}) => {
  return (
			<div className="px-6 py-2 bg-slate-50/30 border-b border-gray-200 flex items-center justify-start gap-6">
				<div className="flex items-center gap-1 text-sm text-gray-700 mr-6 -ml-5">
          <span className="font-semibold">Products</span>
          <span className="text-slate-400">|</span>
          <span className="text-slate-500">{totalElements}</span>
        </div>

      <div className="ml-auto flex items-center gap-3">
        {/* GLOBAL SEARCH */}
        <div className="w-[200px]">
          {/* <label className="text-[10px] font-black text-slate-500 uppercase tracking-widest mb-1 block">
            {t('mediaPowderProductMaster.filter_list.searchGlobal')}
          </label> */}
            <div className="relative">
              <input
                value={searchTerm}
                onChange={(e) => onSearchChange(e.target.value)}
                className="w-full h-[30px] pl-4 pr-10 bg-slate-50 border border-slate-200 rounded-lg text-sm font-medium text-slate-700 focus:ring-2 focus:ring-orange-500/20 outline-none"
                placeholder={t('mediaPowderProductMaster.filter_list.search_placeholder')}
              />
              <span
                className="material-symbols-outlined absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 cursor-pointer text-lg"
                onClick={() => onSearchClick?.()}
              >
                {t('mediaPowderProductMaster.filter_list.search')}
              </span>
            </div>
        </div>

        {/* MEDIA TYPE FILTER */}
        <div className="w-[155px]">
          {/* <label className="text-[10px] font-black text-slate-500 uppercase tracking-widest mb-1 block">
            {filterLabel || t('mediaPowderProductMaster.filter_list.MediaType')}
          </label> */}
          <div className="relative">
            <select
              value={selectedMediaType}
              onChange={(e) => onMediaTypeChange(e.target.value)}
              className="w-full h-[30px] bg-slate-50 border border-slate-200 rounded-lg px-4 text-sm font-medium text-slate-700 focus:ring-2 focus:ring-orange-500/20 outline-none appearance-none cursor-pointer"
            >
              <option value="">{filterPlaceholder || t('mediaPowderProductMaster.filter_list.All Media Types')}</option>
              {mediaTypes.map((item) => (
                <option key={item.id} value={item[valueKey || "name"]}>
                  {item[labelKey || "name"]}
                </option>
              ))}
            </select>
            <span className="material-symbols-outlined absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none text-lg">
              {t('mediaPowder.icons.expand_more')}
            </span>
          </div>
        </div>

        {/* MANUFACTURER */}
        <div className="w-[155px]">
          <div className="relative">
            <select
              value={manufacturerFilter || ""}
              onChange={(e) => onManufacturerChange?.(e.target.value)}
              className="w-full h-[30px] bg-slate-50 border border-slate-200 rounded-lg px-4 text-sm font-medium text-slate-700 appearance-none cursor-pointer"
            >
              <option value="">Manufacturer</option>
              <option value="Sigma-Aldrich">Sigma-Aldrich</option>
              <option value="Oxoid">Oxoid</option>
              <option value="Thermo Fisher">Thermo Fisher</option>
            </select>

            <span className="material-symbols-outlined absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none text-lg">
              {t('mediaPowder.icons.expand_more')}
            </span>
          </div>
        </div>

        {/* STATUS */}
        <div className="w-[150px]">
          <div className="relative">
            <select
              value={statusFilter || ""}
              onChange={(e) => onStatusChange?.(e.target.value)}
              className="w-full h-[30px] bg-slate-50 border border-slate-200 rounded-lg px-4 text-sm font-medium text-slate-700 appearance-none cursor-pointer"
            >
              <option value="">Status</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>

            <span className="material-symbols-outlined absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none text-lg">
              {t('mediaPowder.icons.expand_more')}
            </span>
          </div>
        </div>


        {/* CLEAR FILTER BUTTON */}
        {(searchTerm || selectedMediaType || manufacturerFilter || statusFilter) && (
          <button
            onClick={onClearFilters}
            className="h-[30px] w-[120px] px-4 whitespace-nowrap border border-slate-200 rounded-lg text-xs font-black text-orange-500 hover:text-orange-600 flex items-center justify-center gap-1"
          >
            <span className="material-symbols-outlined text-sm">
              filter_alt_off
            </span>
            Clear Filters
          </button>
        )}
      </div>
      </div>
  );
};

export default ProductMasterFilterBar;